import { linkedSignal, signal, WritableSignal } from '@angular/core';
import { IDetailFormFieldChange } from './detailForm';

export class DetailFormDraft<TDraft extends object> {
  readonly value: WritableSignal<TDraft>;

  private readonly resetRequests = signal(0);

  constructor(source: () => TDraft) {
    this.value = linkedSignal(() => {
      this.resetRequests();
      return source();
    });
  }

  change(fieldChange: IDetailFormFieldChange) {
    this.value.update((draft) => ({ ...draft, [fieldChange.field]: fieldChange.value }));
  }

  reset() {
    this.resetRequests.update((requests) => requests + 1);
  }
}
